import { render } from "./How.vue?vue&type=template&id=4f8ff2c7&scoped=true&ts=true"
import script from "./How.vue?vue&type=script&lang=ts"
export * from "./How.vue?vue&type=script&lang=ts"

import "./How.vue?vue&type=style&index=0&id=4f8ff2c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f8ff2c7"]])

export default __exports__